/**
 * ChannelFab — кнопка «Канал» рядом с «+» (рисуется внутри FabSpeedDial).
 *
 * Живёт в FabSpeedDial, а не на каждой странице, по той же причине, что
 * «Сканировать QR»: обязательное везде действие не должно зависеть от того,
 * вспомнил ли о нём автор очередного экрана.
 *
 * Бейдж двух уровней (решение Павла 02.10.2026):
 *   красный счётчик — адресовано мне (@, ответ на моё, моя Работа);
 *   оранжевая точка — есть новое в видимой мне ленте (решение Павла 02.10.2026,
 *                     была серая — терялась на светлом фоне).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { track } from '../../analytics';
import { useChannel } from './ChannelProvider';

/** Контурная «Рация» (walkie-talkie). */
export function RadioIcon({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 2v5" />
      <rect x="6" y="7" width="12" height="15" rx="2" />
      <path d="M9.5 11h5" />
      <path d="M9.5 14h5" />
      <circle cx="12" cy="18" r="0.8" />
    </svg>
  );
}

export const RADIO_ICON = <RadioIcon />;

export default function ChannelFab() {
  const { t } = useTranslation();
  const ch = useChannel();
  if (!ch || !ch.enabled) return null;
  const { unread } = ch;
  const count = unread.addressed;

  const onClick = () => {
    track('channel_opened', {
      source: 'fab',
      context: ch.scope ? (ch.scope.taskId ? 'task' : 'property') : 'all',
      unread_addressed: count,
      has_new: unread.has_new,
    });
    ch.openChannel();
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={count ? t('channel.fabAriaUnread', { count }) : t('channel.fabAria')}
      data-ph-capture-attribute-component="channel_fab"
      style={{
        position: 'relative',
        width: 44,
        height: 44,
        borderRadius: '50%',
        background: 'var(--bg)',
        color: 'var(--accent)',
        border: '1px solid var(--border)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 3px 12px rgba(0,0,0,0.22)',
        flexShrink: 0,
      }}
    >
      {RADIO_ICON}
      {count > 0 && (
        <span style={{
          position: 'absolute', top: -4, right: -4,
          minWidth: 18, height: 18, padding: '0 5px', borderRadius: 9,
          background: 'var(--red)', color: '#fff', fontSize: 11, fontWeight: 700,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: '2px solid var(--bg)', boxSizing: 'content-box',
        }}>
          {count > 99 ? '99+' : count}
        </span>
      )}
      {!count && unread.has_new && (
        <span style={{
          position: 'absolute', top: 2, right: 2, width: 10, height: 10, borderRadius: '50%',
          background: '#f59e0b', border: '2px solid var(--bg)',
        }} />
      )}
    </button>
  );
}
